import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { getBaseUrl } from "@/lib/utils";

const NotFound = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
    try {
      const base = getBaseUrl();
      const p = location.pathname || '';
      const isAsset = /^\/(Logos|backgrounds|images)\//i.test(p);
      // If user opens a public asset without the base prefix (e.g., /Logos/...) on a base-deployed site,
      // redirect to the base-prefixed URL so the server serves the static file instead of SPA 404.
      if (isAsset && base && base !== '/' && !p.startsWith(base + '/')) {
        window.location.replace(base + p);
        return;
      }
    } catch (e) {
      // noop
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4">404</h1>
        <p className="text-xl text-gray-600 mb-4">Oops! Page not found</p>
        <a href={`${getBaseUrl().replace(/\/$/, '')}/`} className="text-blue-500 hover:text-blue-700 underline">
          Return to Home
        </a>
      </div>
    </div>
  );
};

export default NotFound;
